import { ConsignmentStockOutUpdatePage } from "@/features/consignment-stockout/pages/ConsignmentStockOutUpdatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-stockout/$id/update")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["consignment_stock_out.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ConsignmentStockOutUpdatePage,
});
